import { engageLabCore } from '@jg/qiankun-micro-tool';
import { message } from 'ant-design-vue';
import { getCookie } from '../cookie';
import errorInterceptor from './error-interceptor';
export type MethodType = 'GET' | 'POST' | 'PUT' | 'DELETE';
export type QueryBase<DATA> = {
  data: DATA;
  code: number;
  msg: string;
};

const taxValidateCodes = [20097, 20098, 20099]; // 支付、结账时税务信息校验失败

let onceAutoTip: boolean | null = null;

export function setOnceAutoTip(autoTip: boolean) {
  onceAutoTip = autoTip;
}

export default <T>(
  url: string,
  method: MethodType,
  body?: Record<string, string> | null,
  headers?: HeadersInit,
  autoTip = true,
  responseType?: 'json' | 'blob' | 'text',
): Promise<QueryBase<T>> => {
  if (onceAutoTip !== null) {
    autoTip = onceAutoTip;
    onceAutoTip = null;
  }
  const _url = url.startsWith('http') ? url : `${process.env.API_BASE_URL ?? ''}${url}`;
  return new Promise((resolve, reject) => {
    fetch(
      _url,
      Object.assign(
        {
          method,
          headers: Object.assign(
            {
              // 预制头
              Locale: engageLabCore.locale.takeImmediately(),
              Authorization: 'Bearer ' + engageLabCore.token.takeImmediately(),
              'Content-Type': 'application/json',
            },
            headers,
          ),
        },
        body && { body: JSON.stringify(body) },
      ),
    )
      .then(res => {
        if (responseType == 'blob' && res.blob) return res.blob();
        return headers && (headers as any).buffer ? res.arrayBuffer() : res.json();
      })
      .then(res => {
        // 拦截业务层报错
        if (res.code && !taxValidateCodes.includes(res.code)) errorInterceptor(res, autoTip);
        return res;
      })
      .then(resolve)
      .catch(err => {
        if (autoTip) message.error(err.message);
        reject(err);
      });
  });
};
